import React from 'react'
import { Button, Col } from "antd";

import { ActivityIndicator, ProgressControl} from '@seims/shared';

export default function UploadProgress({ setProgressState, progress, loading }) {
    const onBack = () => {
        setProgressState(0);
    };

    return (
        <div>
            {loading && progress < 1 && (
                <ProgressControl
                    loading={loading}
                    percent={parseInt(progress * 100)}
                    text="File being transferred to the server, please wait..."
                />
            )}

            {loading && progress === 1 && <ActivityIndicator visible={loading} />}

            <Col xs={2}>
                {
                    !loading && (
                        <Button
                            className="right-align-button"
                            onClick={onBack}
                            type="deafult"
                            style={{ marginTop: "20px" }}
                            disabled={loading}
                        >
                            Back
                        </Button>
                    )
                }
            </Col>
        </div>
    )
}
